// extracted by mini-css-extract-plugin
export default {"smTd":"WinnersList_smTd__XPGrh","priceTd":"WinnersList_priceTd__rLqME"};